<eff-popup-header
    [title]="title"
    [dialogRef]="dialogRef"
    data-uiid="new-eff-sources-popup-header"
></eff-popup-header>
<div class="dialog-body">
    @if (executionData && executionData.length > 0) {
        <div data-uiid="new-eff-sources-popup-execution-table">
            <generic-pagination-list-manager
                [config]="this.executionConfig"
            ></generic-pagination-list-manager>
        </div>
    }
</div>
